import config from '@/config';
import axiosInstance from '@/utils/api-new';
import {
  NotificationService,
  GetNotificationsResponse,
  SetNotificationsRequest,
  SetNotificationsStatusResponse,
  SetReadAllResponse,
} from '@/types/services/notification';

export const notificationService: NotificationService = {
  async getNotifications(userId: string): Promise<GetNotificationsResponse> {
    const from = new Date();
    from.setDate(from.getDate() - 30);
    const url = `/notifications/${config.apiVersion}/${userId}?from=${from.toISOString()}`;
    return axiosInstance.get(url);
  },
  async setNotificationsStatus(
    userId: string,
    notificationsStatus: SetNotificationsRequest[]
  ): Promise<SetNotificationsStatusResponse> {
    const url = `/notifications/${config.apiVersion}/${userId}/status`;
    return axiosInstance.patch(url, notificationsStatus);
  },
  async setReadAll(userId: string): Promise<SetReadAllResponse> {
    const url = `/notifications/${config.apiVersion}/${userId}/read-all`;
    return axiosInstance.patch(url);
  },
};
